import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUndoLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.0352 3.96967C11.3281 4.26257 11.3281 4.73744 11.0352 5.03033L8.31555 7.75H11.4829C17.4212 7.75 20.4658 14.8653 16.3656 19.1608L16.3656 19.1608L15.5474 20.0179C15.2614 20.3175 14.7866 20.3285 14.487 20.0425C14.1874 19.7565 14.1764 19.2817 14.4624 18.9821L15.2806 18.125C15.2806 18.125 15.2806 18.125 15.2806 18.125C18.4696 14.7841 16.1016 9.25 11.4829 9.25H8.31555L11.0352 11.9697C11.3281 12.2626 11.3281 12.7374 11.0352 13.0303C10.7423 13.3232 10.2675 13.3232 9.97457 13.0303L5.97455 9.03033C5.8339 8.88968 5.75488 8.69891 5.75488 8.5C5.75488 8.30109 5.8339 8.11032 5.97455 7.96967L9.97457 3.96967C10.2675 3.67678 10.7423 3.67678 11.0352 3.96967Z",
		fill: "currentColor"
	})
});
export default SvgUndoLine;
